// Shared lead display helpers — used by LeadList and the Today dashboard.

export const URGENCY_COLOR = {
    "P1-storm": "bg-red-600 text-white",
    "P1-safety-flag": "bg-red-600 text-white",
    "P2-hoa-deadline": "bg-yellow-500 text-black",
    "P3-active-pest": "bg-[var(--color-accent)] text-white",
    "P4-rescreen": "bg-[var(--color-accent)] text-white",
    "P5-door": "bg-[var(--color-line)] text-[var(--color-text)]",
    "P6-routine": "bg-[var(--color-line)] text-[var(--color-text)]",
    "P7-property-manager": "bg-[var(--color-accent)] text-white",
    "P8-need-info": "bg-[var(--color-line)] text-[var(--color-text)]",
};

// Friendly labels for John's daily view. Engineering code stays in the
// badge's `title` attribute so audit/grep still finds it.
export const URGENCY_LABEL = {
    "P1-storm": "Storm — urgent",
    "P1-safety-flag": "Safety flag — urgent",
    "P2-hoa-deadline": "HOA deadline",
    "P3-active-pest": "Bugs getting in",
    "P4-rescreen": "Rescreen",
    "P5-door": "Screen door",
    "P6-routine": "Routine",
    "P7-property-manager": "Property manager",
    "P8-need-info": "Needs more info",
};

export function timeAgo(iso) {
    if (!iso) return "";
    const diff = Date.now() - new Date(iso).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 1) return "just now";
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    const d = Math.floor(h / 24);
    return `${d}d ago`;
}

// Format a US 10-digit phone as (XXX) XXX-XXXX. Accepts +1XXXXXXXXXX,
// 1XXXXXXXXXX, or XXXXXXXXXX. Anything else falls back to the raw value.
export function formatPhone(raw) {
    if (!raw) return "";
    const digits = String(raw).replace(/\D/g, "");
    let core = digits;
    if (core.length === 11 && core.startsWith("1")) core = core.slice(1);
    if (core.length !== 10) return raw;
    return `(${core.slice(0, 3)}) ${core.slice(3, 6)}-${core.slice(6)}`;
}
